import { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

export const useLanguage = () => {
    const { t, i18n } = useTranslation("translation");

    const changeLanguage = useCallback(
        (language: string): Promise<void | TFunction> => {
            return new Promise((resolve, reject) => {
                if (language !== i18n.language) {
                    i18n.changeLanguage(language).then(resolve).catch(reject);
                } else {
                    resolve();
                }
            });
        },
        []
    );

    return {
        language: i18n.language,
        changeLanguage,
        t,
    };
};
